import React from 'react';
import { LogoIcon } from '@/components/Logo';
import { useFormsTranslations } from '@/hooks/useFormsTranslations';

export const SplashLoader: React.FC = () => {
  const forms = useFormsTranslations();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background">
      <div className="flex flex-col items-center justify-center space-y-4">
        <LogoIcon
          className="size-16 animate-spin-slow text-primary-500"
          role="img"
          aria-label={forms.common.aria.loading}
        />
        <div className="text-sm text-muted-foreground">{forms.common.aria.loading}</div>
      </div>
    </div>
  );
};
